import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement,
} from '@stripe/react-stripe-js';
import { Component } from 'react';

import { Box } from '@hivebrite/design-system/Box';

import { Label } from 'hb-react/shared/components/DesignSystem/Input';

const styling = {
  style: {
    base: {
      fontSize: '14px',
      color: '#424770',
      letterSpacing: '0.025em',
      fontFamily: 'Source Code Pro, monospace',
      '::placeholder': {
        color: '#aab7c4',
      },
    },
    invalid: {
      color: '#9e2146',
    },
  },
};

class SplitedCardFields extends Component {
  state = {
    numberError: null,
    expiryError: null,
    cvcError: null,
  };

  handleChange = (change, field) => {
    if (change.error) {
      this.setState({ [`${field}Error`]: change.error.message });
    } else {
      this.setState({ [`${field}Error`]: null });
    }
  };

  // RENDERERS

  static renderError(error) {
    if (error) {
      return (
        <div className="field_with_errors">
          <span className="error">{error}</span>
        </div>
      );
    }
  }

  render() {
    const { numberError, expiryError, cvcError } = this.state;

    return (
      <Box flexDirection="column" with="100%">
        <Box
          flexDirection="column"
          with="100%"
          mb={3}
          data-testid="card-number"
        >
          <Box mb={2}>
            <Label htmlFor="stripe-card-number">
              {s__('Stripe|Card number')}
            </Label>
          </Box>
          <CardNumberElement
            id="stripe-card-number"
            onChange={(e) => this.handleChange(e, 'number')}
            options={styling}
          />
          {SplitedCardFields.renderError(numberError)}
        </Box>

        <Box
          flexDirection="column"
          with="100%"
          mb={3}
          data-testid="card-expiry"
        >
          <Box mb={2}>
            <Label htmlFor="stripe-card-expiry">
              {s__('Stripe|Expiration date')}
            </Label>
          </Box>
          <CardExpiryElement
            id="stripe-card-expiry"
            onChange={(e) => this.handleChange(e, 'expiry')}
            options={styling}
          />
          {SplitedCardFields.renderError(expiryError)}
        </Box>
        <Box flexDirection="column" with="100%" mb={3} data-testid="card-cvc">
          <Box mb={2}>
            <Label htmlFor="stripe-card-cvc">{s__('Stripe|CVC')}</Label>
          </Box>
          <CardCvcElement
            id="stripe-card-cvc"
            onChange={(e) => this.handleChange(e, 'cvc')}
            options={styling}
          />
          {SplitedCardFields.renderError(cvcError)}
        </Box>
      </Box>
    );
  }
}

export default SplitedCardFields;
